module.exports = __webpack_public_path__ + "static/img/works-01.d8cff0b6.png";